export enum COOKIE_NAME {
  V2_CREW_ID = 'cmAuthenticationCrewId',
  V2_CREW_TOKEN = 'cmAuthenticationCrewToken',
  V2_USER_ID = 'cmAuthenticationUserId',
  V2_USER_TOKEN = 'cmAuthenticationUserToken',
  V3_CREW_TOKEN = 'cmV3AuthenticationCrewToken',
  V3_USER_TOKEN = 'cmV3AuthenticationUserToken',
}
